import { Model } from '../parents/model';
import { UserModel } from "@/common/models/user.model";
import { AttachmentModel } from "@/common/models/attachment.model";

export class EcoChallengeFileModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_STATUS = 'status';

  static ATTR_PATH = 'path';

  static ATTR_ADOBE_JOB_ID = 'adobe_job_id';

  static ATTR_ATTACHMENT_ID = 'attachment_id';

  static ATTR_USER_ID = 'user_id';

  static ATTR_CREATED_AT = 'created_at';

  static EMBED_ECO_CHALLENGE_FILE_ORDERS_COUNT = 'eco_challenge_file_orders_count';

  static EMBED_USER = 'user';

  static EMBED_ATTACHMENT = 'attachment';

  get name() {
    return this.attributes[EcoChallengeFileModel.ATTR_NAME];
  }

  get status() {
    return this.attributes[EcoChallengeFileModel.ATTR_STATUS];
  }

  get path() {
    return this.attributes[EcoChallengeFileModel.ATTR_PATH];
  }

  get adobeJobId() {
    return this.attributes[EcoChallengeFileModel.ATTR_ADOBE_JOB_ID];
  }

  get attachmentId() {
    return this.attributes[EcoChallengeFileModel.ATTR_ATTACHMENT_ID];
  }

  get userId() {
    return this.attributes[EcoChallengeFileModel.ATTR_USER_ID];
  }

  get createdAt() {
    return this.attributes[EcoChallengeFileModel.ATTR_CREATED_AT];
  }

  get ecoChallengeFileOrdersCount() {
    return this.embeds[EcoChallengeFileModel.EMBED_ECO_CHALLENGE_FILE_ORDERS_COUNT];
  }

  get user() {
    return new UserModel(this.embeds[EcoChallengeFileModel.EMBED_USER]);
  }

  get attachment() {
    return new AttachmentModel(this.embeds[EcoChallengeFileModel.EMBED_ATTACHMENT]);
  }
}
